import type { RootState } from 'redux/rootReducer';
import {
  call,
  takeEvery,
  put,
  select,
  SagaReturnType
} from 'redux-saga/effects';
import {
  setPlanGroups,
  SavePlanGroupAction,
  DeletePlanGroupAction
} from 'redux/actionCreators';

import {
  savePlanGroup,
  updatePlanGroup as UpdatePlanGroup,
  deletePlanGroup as DeletePlanGroup
} from 'RestAPIs/plan-groups';

export function* saveNewPlanGroup() {
  yield takeEvery(
    'SAVE_NEW_PLANGROUP',
    function* ({ payload }: SavePlanGroupAction) {
      const { name, costCenters } = payload;
      const response: SagaReturnType<typeof savePlanGroup> = yield call(
        savePlanGroup,
        { name, costCenters }
      );
      const planGroup = response.data;

      planGroup.uniqId = `${planGroup.id}-group`;
      const { planGroups }: RootState = yield select(
        (state: RootState) => state
      );
      yield put(setPlanGroups([...planGroups, planGroup]));
    }
  );
}

export function* updatePlanGroup() {
  yield takeEvery(
    'UPDATE_PLANGROUP',
    function* ({ payload }: SavePlanGroupAction) {
      yield call(UpdatePlanGroup, payload);
      const { planGroups }: RootState = yield select(
        (state: RootState) => state
      );
      const planGroupIndex = planGroups.findIndex(
        ({ id }) => id === payload.id
      );
      const planGroup = {
        ...payload,
        id: payload.id as number,
        uniqId: `${payload.id}-group`
      };
      yield put(
        setPlanGroups([
          ...planGroups.slice(0, planGroupIndex),
          planGroup,
          ...planGroups.slice(planGroupIndex + 1)
        ])
      );
    }
  );
}

export function* deletePlanGroup() {
  yield takeEvery(
    'DELETE_PLANGROUP',
    function* ({ payload: id }: DeletePlanGroupAction) {
      yield call(DeletePlanGroup, id);
      const { planGroups }: RootState = yield select(
        (state: RootState) => state
      );
      yield put(setPlanGroups(planGroups.filter((pg) => pg.id !== id)));
    }
  );
}
